import i18n from '@/lang'
export function extractValue(value, map) {
  if (value) {
    for (let i = 0; i < map.length; i++) {
      if (parseInt(map[i].value, 10) === parseInt(value, 10)) {
        return map[i]
      }
    }
    return {}
  } else {
    if (parseInt(value, 10) === 0) {
      for (let i = 0; i < map.length; i++) {
        if (parseInt(map[i].value, 10) === parseInt(value, 10)) {
          return map[i]
        }
      }
    }
    return JSON.parse(JSON.stringify(map))
  }
}

// 商户类型 1：个人，2：企业
// 业务类型 1：自营，2：加盟
export function businessTypeMap(value) {
  const map = [{
    value: 1,
    label: i18n.t('operation.self_operated')
  }, {
    value: 2,
    label: i18n.t('operation.franchise')
  }]
  return extractValue(value, map)
}

// 商户类型 1：个人，2：企业
export function merchantTypeMap(value) {
  const map = [{
    value: 1,
    label: i18n.t('map.merchant_type_1'),
    type: 'info'
  }, {
    value: 2,
    label: i18n.t('map.merchant_type_2'),
    type: 'info'
  }]
  return extractValue(value, map)
}

// 手续费承担模式 1：商户承担，2：用户承担
export function transactionFeeMode(value) {
  const map = [{
    value: 1,
    label: i18n.t('merchant.transaction_fee_charge_mode1'),
    type: 'info'
  }, {
    value: 2,
    label: i18n.t('merchant.transaction_fee_charge_mode2'),
    type: 'info'
  }]
  return extractValue(value, map)
}

// 商户状态 1：有效，2：无效
export function merchantStatusMap(value) {
  const map = [{
    value: 1,
    label: i18n.t('map.merchant_status_1'),
    type: 'success'
  }, {
    value: 2,
    label: i18n.t('map.merchant_status_2'),
    type: 'primary'
  }]
  return extractValue(value, map)
}

// KYC 状态映射 1:未认证 2:认证中 3:已认证 4:审核驳回
export function kycStatusMap(value) {
  const map = [
    { value: 1, label: i18n.t('system.kyc_unverified'), className: 'kyc-1' },
    { value: 2, label: i18n.t('system.kyc_pending'), className: 'kyc-2' },
    { value: 3, label: i18n.t('system.kyc_verified'), className: 'kyc-3' },
    { value: 4, label: i18n.t('system.kyc_rejected'), className: 'kyc-4' }
  ]
  return extractValue(value, map)
}

// 商户签约类型 1：平台直签，2：代理商签约
export function merchantOriginMap(value) {
  const map = [{
    value: 1,
    label: i18n.t('map.merchant_origin_1'),
    type: 'info'
  }, {
    value: 2,
    label: i18n.t('map.merchant_origin_2'),
    type: 'info'
  }]
  return extractValue(value, map)
}

// 商户所支持业务类型 1：支付，2：代付
export function merchantProductMap(value) {
  const map = [{
    value: 1,
    label: i18n.t('map.merchant_product_1'),
    type: 'info'
  }, {
    value: 2,
    label: i18n.t('map.merchant_product_2'),
    type: 'info'
  }, {
    value: 4,
    label: i18n.t('map.merchant_product_4'),
    type: 'info'
  }]
  return extractValue(value, map)
}

// 商户身份证类型: 1.身份证
export function personIDTypeMap(value) {
  const map = [{
    value: 1,
    label: i18n.t('map.id_num_type_1'),
    type: 'success'
  },
  {
    value: 2,
    label: i18n.t('map.id_num_type_2'),
    type: 'success'
  },
  {
    value: 3,
    label: i18n.t('map.id_num_type_3'),
    type: 'success'
  },
  {
    value: 4,
    label: i18n.t('map.id_num_type_4'),
    type: 'success'
  },
  {
    value: 5,
    label: i18n.t('map.id_num_type_5'),
    type: 'success'
  },
  {
    value: 6,
    label: i18n.t('map.id_num_type_6'),
    type: 'success'
  },
  {
    value: 7,
    label: i18n.t('map.id_num_type_7'),
    type: 'success'
  },
  {
    value: 8,
    label: i18n.t('map.id_num_type_8'),
    type: 'success'
  },
  {
    value: 9,
    label: i18n.t('map.id_num_type_9'),
    type: 'success'
  },
  {
    value: 10,
    label: i18n.t('map.id_num_type_10'),
    type: 'success'
  }]
  return extractValue(value, map)
}

// 息费类型 1:比例计费 2:固定金额
export function feeTypeMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.fee_type_1'),
      type: 'success'
    }, {
      value: 2,
      label: i18n.t('map.fee_type_2'),
      type: 'warning'
    }
  ]
  return extractValue(value, map)
}

// 渠道策略类型 1:统一费率 2:阶梯汇率
export function feeStructureMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.fee_structure_1'),
      type: 'success'
    }, {
      value: 2,
      label: i18n.t('map.fee_structure_2'),
      type: 'warning'
    }
  ]
  return extractValue(value, map)
}

// 支付交易状态 1:支付中 2:支付成功 3:支付失败
export function payTransactionStatusMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.pay_trans_status_1'),
      type: 'warning'
    }, {
      value: 2,
      label: i18n.t('map.pay_trans_status_2'),
      type: 'success'
    },
    {
      value: 3,
      label: i18n.t('map.pay_trans_status_3'),
      type: 'danger'
    }
  ]
  return extractValue(value, map)
}

// 支付交易状态 1:未支付 2:支付成功 3:支付失败 4:支付撤销 5:支付撤销中
export function payTransactionStatusVoidMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.pay_trans_status_1'),
      type: 'warning'
    }, {
      value: 2,
      label: i18n.t('map.pay_trans_status_2'),
      type: 'success'
    },
    {
      value: 3,
      label: i18n.t('map.pay_trans_status_3'),
      type: 'danger'
    },
    {
      value: 4,
      label: i18n.t('map.pay_trans_status_4'),
      type: 'danger'
    },
    {
      value: 5,
      label: i18n.t('map.pay_trans_status_5'),
      type: 'danger'
    }
  ]
  return extractValue(value, map)
}

// 支付交易状态 1:支付中 2:支付成功 3:支付失败
export function simulatePayTransactionStatusMap(value) {
  const map = [
    {
      value: 2,
      label: i18n.t('map.pay_trans_status_2'),
      type: 'success'
    },
    {
      value: 3,
      label: i18n.t('map.pay_trans_status_3'),
      type: 'danger'
    }
  ]
  return extractValue(value, map)
}

// 代付交易状态  1:等待付款 2:付款中 3:付款成功 4:付款失败
export function poTransStatusMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.po_trans_status_2'),
      type: 'warning'
    }, {
      value: 2,
      label: i18n.t('map.po_trans_status_2'),
      type: 'warning'
    },
    {
      value: 3,
      label: i18n.t('map.po_trans_status_3'),
      type: 'success'
    },
    {
      value: 4,
      label: i18n.t('map.po_trans_status_4'),
      type: 'danger'
    }, {
      value: 5,
      label: i18n.t('map.po_trans_status_5'),
      type: 'warning'
    }
  ]
  return extractValue(value, map)
}

// 代付交易状态  1:等待付款 2:付款中 3:付款成功 4:付款失败 99:已退款
export function poTransStatusWithRefundMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.po_trans_status_2'),
      type: 'warning'
    }, {
      value: 2,
      label: i18n.t('map.po_trans_status_2'),
      type: 'warning'
    },
    {
      value: 3,
      label: i18n.t('map.po_trans_status_3'),
      type: 'success'
    },
    {
      value: 4,
      label: i18n.t('map.po_trans_status_4'),
      type: 'danger'
    }, {
      value: 5,
      label: i18n.t('map.po_trans_status_5'),
      type: 'warning'
    }, {
      value: 99,
      label: i18n.t('map.po_trans_status_99'),
      type: 'info'
    }
  ]
  return extractValue(value, map)
}
// 提现交易状态 1：提现中 2：提现完成 3：提现失败 4: 待处理 5：待重试 6：重试中 7: 待定价 8:待确定
export function withdrawTransactionStatusMap(value) {
  const map = [
    {
      value: 4,
      label: i18n.t('map.withdraw_trans_status_4'),
      type: ''
    },
    {
      value: 1,
      label: i18n.t('map.withdraw_trans_status_1'),
      type: 'warning'
    }, {
      value: 2,
      label: i18n.t('map.withdraw_trans_status_2'),
      type: 'success'
    },
    {
      value: 3,
      label: i18n.t('map.withdraw_trans_status_3'),
      type: 'danger'
    },
    {
      value: 5,
      label: i18n.t('map.withdraw_trans_status_5'),
      type: 'info'
    },
    {
      value: 6,
      label: i18n.t('map.withdraw_trans_status_6'),
      type: 'warning'
    },
    {
      value: 7,
      label: i18n.t('map.withdraw_trans_status_7'),
      type: 'warning'
    },
    {
      value: 8,
      label: i18n.t('map.withdraw_trans_status_8'),
      type: 'info'
    }
  ]
  return extractValue(value, map)
}

// 余额类型 1：支付结算 2：代付 3：充值 4：提现 5：代付失败充值
export function balanceTypeMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.balance_type_1'),
      color: '#4CAF50'
    }, {
      value: 2,
      label: i18n.t('map.balance_type_2'),
      color: '#9C27B0'
    },
    {
      value: 3,
      label: i18n.t('map.balance_type_3'),
      color: '#7CB342'
    },
    {
      value: 4,
      label: i18n.t('map.balance_type_4'),
      color: '#03A9F4'
    },
    {
      value: 5,
      label: i18n.t('map.balance_type_5'),
      color: '#FF0000'
    },
    {
      value: 6,
      label: i18n.t('map.balance_type_6'),
      color: '#FFA07A'
    },
    {
      value: 7,
      label: i18n.t('map.balance_type_7'),
      color: '#FA8072'
    },
    {
      value: 8,
      label: i18n.t('map.balance_type_8'),
      color: '#9CCC65'
    },
    {
      value: 9,
      label: i18n.t('map.balance_type_9'),
      color: '#FFC107'
    },
    {
      value: 10,
      label: i18n.t('map.balance_type_10'),
      color: '#CDDC39'
    },
    {
      value: 13,
      label: i18n.t('map.balance_type_13'),
      type: 'success'
    },
    {
      value: 14,
      label: i18n.t('map.balance_type_14'),
      type: 'success'
    },
    {
      value: 22,
      label: i18n.t('map.balance_type_22'),
      color: '#FF0000'
    }, {
      value: 19,
      label: i18n.t('map.balance_type_19'),
      color: '#329bc9'
    },
    {
      value: 20,
      label: i18n.t('map.balance_type_20'),
      color: '#ec410b'
    },
    {
      value: 23,
      label: i18n.t('map.balance_type_23'),
      color: '#03A9F4'
    },
    {
      value: 24,
      label: i18n.t('map.balance_type_24'),
      color: '#7CB342'
    },
    {
      value: 25,
      label: i18n.t('map.balance_type_25'),
      color: '#03A9F4'
    },
    {
      value: 26,
      label: i18n.t('map.balance_type_26'),
      color: '#7CB342'
    },
    {
      value: 27,
      label: i18n.t('map.balance_type_27'),
      color: '#4CAF50'
    },
    {
      value: 28,
      label: i18n.t('map.balance_type_28'),
      color: '#e7c8c3'
    },
    {
      value: 38,
      label: i18n.t('map.balance_type_38_balance_detail'),
      color: '#7b5ef8'
    },
    {
      value: 29,
      label: i18n.t('map.balance_type_29'),
      color: '#f8c1c1'
    },
    {
      value: 30,
      label: i18n.t('map.balance_type_30'),
      color: '#f1ccc6'
    },
    {
      value: 31,
      label: i18n.t('map.balance_type_31'),
      color: '#d6c4c1ff'
    },
    {
      value: 32,
      label: i18n.t('map.balance_type_32'),
      color: '#ee7664ff'
    },
    {
      value: 33,
      label: i18n.t('map.balance_type_33'),
      color: '#6d4f4aff'
    },
    {
      value: 34,
      label: i18n.t('map.balance_type_34'),
      color: '#bba4a1ff'
    },
    {
      value: 35,
      label: i18n.t('map.balance_type_35'),
      color: '#cf7d10'
    },
    {
      value: 36,
      label: i18n.t('map.balance_type_36'),
      color: '#8B4513'
    },
    {
      value: 37,
      label: i18n.t('map.balance_type_37'),
      color: '#DC143C'
    }
  ]
  return extractValue(value, map)
}

// 代理余额类型
export function agentBalanceTypeMap(value) {
  const map = [
    {
      value: 4,
      label: i18n.t('map.balance_type_4'),
      color: '#03A9F4'
    },
    {
      value: 15,
      label: i18n.t('map.balance_type_15'),
      color: '#673AB7'
    },
    {
      value: 16,
      label: i18n.t('map.balance_type_16'),
      color: '#E91E63'
    },
    {
      value: 18,
      label: i18n.t('map.balance_type_18'),
      color: '#FF0000'
    },
    {
      value: 9,
      label: i18n.t('map.balance_type_9'),
      color: '#FFC107'
    },
    {
      value: 10,
      label: i18n.t('map.balance_type_10'),
      color: '#CDDC39'
    },
    {
      value: 21,
      label: i18n.t('map.balance_type_21'),
      color: '#22deff'
    },
    {
      value: 22,
      label: i18n.t('map.balance_type_22'),
      color: '#FF0000'
    }
  ]
  return extractValue(value, map)
}

// 账单上传状态 1.上传成功 2：确认对账
export function uploadStatusMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.upload_status_1'),
      type: 'warning'
    }, {
      value: 2,
      label: i18n.t('map.upload_status_2'),
      type: 'success'
    }
  ]
  return extractValue(value, map)
}

export function simulateRefundTypeMap(value) {
  const map = [
    {
      value: '2',
      label: i18n.t('map.refunding_status_2'),
      type: 'success'
    },
    {
      value: '3',
      label: i18n.t('map.refunding_status_3'),
      type: 'danger'
    },
    {
      value: '4',
      label: i18n.t('map.refunding_status_6'),
      type: 'success'
    }
  ]
  return extractValue(value, map)
}

// 对账状态 1: 未对账 2：对账中 3：对账完成
export function dealStatusMap(value) {
  const map = [
    {
      value: 0,
      label: i18n.t('map.deal_status_0'),
      type: 'info'
    }, {
      value: 1,
      label: i18n.t('map.deal_status_1'),
      type: 'info'
    }, {
      value: 2,
      label: i18n.t('map.deal_status_2'),
      type: 'warning'
    }, {
      value: 3,
      label: i18n.t('map.deal_status_3'),
      type: 'success'
    }
  ]
  return extractValue(value, map)
}

// 代付类型 1:接口代付 2:文件批量付款 3:提现
export function poTransactionTypeMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.po_trans_type_1'),
      type: 'success'
    }, {
      value: 2,
      label: i18n.t('map.po_trans_type_2'),
      type: 'warning'
    }, {
      value: 3,
      label: i18n.t('map.po_trans_type_3'),
      type: 'warning'
    }
  ]
  return extractValue(value, map)
}

// 支付类型 1:接口支付 2:商户充值业务
export function payTransactionTypeMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.pay_trans_type_1'),
      type: 'success'
    }, {
      value: 2,
      label: i18n.t('map.pay_trans_type_2'),
      type: 'warning'
    }
  ]
  return extractValue(value, map)
}

// 充值记录状态 1：充值中 2：充值完成 3：充值失败 4:拒绝
export function rechargeStatusMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.recharge_status_1'),
      type: 'warning'
    }, {
      value: 2,
      label: i18n.t('map.recharge_status_2'),
      type: 'success'
    },
    {
      value: 3,
      label: i18n.t('map.recharge_status_3'),
      type: 'danger'
    },
    {
      value: 4,
      label: i18n.t('map.recharge_status_4'),
      type: 'info',
      class: 'recharge-rejected'
    }
  ]
  return extractValue(value, map)
}

// 渠道类型;1:支付渠道 2:代付渠道
export function instituteTypeMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.institute_type_1'),
      type: 'success'
    }, {
      value: 2,
      label: i18n.t('map.institute_type_2'),
      type: 'warning'
    }
  ]
  return extractValue(value, map)
}

// 客服工单处理列表 1：未处理 2：处理中 3：已处理
export function csTicketStatusMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.ticket_status_1'),
      type: 'danger'
    }, {
      value: 2,
      label: i18n.t('map.ticket_status_2'),
      type: 'warning'
    },
    {
      value: 3,
      label: i18n.t('map.ticket_status_3'),
      type: 'success'
    }
  ]
  return extractValue(value, map)
}

export function instituteRateTypeMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.institute_rate_type_1'),
      type: 'warning'
    }, {
      value: 2,
      label: i18n.t('map.institute_rate_type_2'),
      type: 'info'
    },
    {
      value: 3,
      label: i18n.t('map.institute_rate_type_3'),
      type: 'danger'
    },
    {
      value: 4,
      label: i18n.t('map.institute_rate_type_4'),
      type: 'success'
    },
    {
      value: 5,
      label: i18n.t('map.institute_rate_type_5'),
      type: 'success'
    },
    {
      value: 6,
      label: i18n.t('map.institute_rate_type_6'),
      type: 'success'
    }
  ]
  return extractValue(value, map)
}

// 存款余额变动类型
export function actionTypeChange(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.action_type_1'),
      type: 'info'
    }, {
      value: 2,
      label: i18n.t('map.action_type_2'),
      type: 'warning'
    }
  ]
  return extractValue(value, map)
}

export function billPaymentChannelCodeMap(value) {
  const map = [
    {
      value: 'GCASH_STATIC_VA',
      label: i18n.t('map.channel_code_1'),
      type: 'info'
    }, {
      value: 'PAYMAYA_STATIC_VA',
      label: i18n.t('map.channel_code_2'),
      type: 'warning'
    }, {
      value: '7ELEVEN_STATIC_VA',
      label: i18n.t('map.channel_code_3'),
      type: 'warning'
    }, {
      value: 'MLH_STATIC_VA',
      label: i18n.t('map.channel_code_4'),
      type: 'warning'
    }, {
      value: 'RDP_STATIC_VA',
      label: i18n.t('map.channel_code_5'),
      type: 'warning'
    }
  ]
  return extractValue(value, map)
}

export function qrChannelCodeMap(value) {
  const map = [
    {
      value: 'QRPH_STATIC_QR',
      label: i18n.t('map.channel_code_6'),
      type: 'info'
    }, {
      value: 'QRPH_DYNAMIC_QR',
      label: i18n.t('map.channel_code_7'),
      type: 'warning'
    }, {
      value: 'QRPH_HYBRID_QR',
      label: i18n.t('map.channel_code_8'),
      type: 'warning'
    }, {
      value: 'GCASH_DYNAMIC_QR',
      label: 'GCASH_DYNAMIC_QR',
      type: 'warning'
    }
  ]
  return extractValue(value, map)
}

export function bankTransferChannelCodeMap(value) {
  const map = [
    {
      value: 'INSTA_TRANSFER_ACC',
      label: i18n.t('map.channel_code_9'),
      type: 'info'
    },
    {
      value: 'PESONET_TRANSFER_ACC',
      label: i18n.t('map.channel_code_10'),
      type: 'info'
    }
  ]
  return extractValue(value, map)
}

// 只适用于工单
export function ticketPaymentMethodMap(value) {
  const map = [{
    value: 1,
    label: 'QR Code'
  }, {
    value: 2,
    label: 'Bill Payment'
  }, {
    value: 3,
    label: 'Bank Transfer'
  }]
  return extractValue(value, map)
}

// payin 表 pay_product_type对应
export function payinPaymentMethodMap(value) {
  const map = [
    {
      value: 1,
      label: 'Dynamic Payment Code'
    }, {
      value: 2,
      label: 'Static Payment Code'
    }, {
      value: 3,
      label: 'Merchant-presented QR'
    }, {
      value: 4,
      label: 'Web Payment'
    }, {
      value: 5,
      label: 'Static QRIS'
    }]
  return extractValue(value, map)
}

export function withdrawTypeMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.withdraw_type_1')
    }, {
      value: 2,
      label: i18n.t('map.withdraw_type_2')
    }

  ]
  return extractValue(value, map)
}

export function autoWithdrawTypeMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.auto_withdraw_type_1')
    }, {
      value: 2,
      label: i18n.t('map.auto_withdraw_type_2')
    }

  ]
  return extractValue(value, map)
}

export function vaAccountAuditStatusMap(value) {
  const map = [{
    value: 1,
    label: i18n.t('map.va_account_aduit_status_1'),
    type: 'info'
  }, {
    value: 2,
    label: i18n.t('map.va_account_aduit_status_2'),
    type: 'success'
  },
  {
    value: 3,
    label: i18n.t('map.va_account_aduit_status_3'),
    type: 'danger'
  }]
  return extractValue(value, map)
}

// 审核列表 1：待审核 2：驳回 3：拒绝 4：通过
export function auditStatusMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.mch_audit_status_1'),
      type: 'info'
    }, {
      value: 2,
      label: i18n.t('map.mch_audit_status_2'),
      type: 'warning'
    },
    {
      value: 3,
      label: i18n.t('map.mch_audit_status_3'),
      type: 'danger'
    },
    {
      value: 4,
      label: i18n.t('map.mch_audit_status_4'),
      type: 'success'
    }
  ]
  return extractValue(value, map)
}

export function switchStatusMap(value) {
  const map = [{
    value: 1,
    label: i18n.t('map.switch_status_1'),
    type: 'success'
  }, {
    value: 2,
    label: i18n.t('map.switch_status_2'),
    type: 'danger'
  }]

  return extractValue(value, map)
}

// 资金来源
export function fundsSourceMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.funds_source_1'),
      type: 'success'
    }, {
      value: 2,
      label: i18n.t('map.funds_source_2'),
      type: 'success'
    }, {
      value: 3,
      label: i18n.t('map.funds_source_3'),
      type: 'success'
    }, {
      value: 4,
      label: i18n.t('map.funds_source_4'),
      type: 'success'
    }, {
      value: 99,
      label: i18n.t('map.funds_source_99'),
      type: 'success'
    }]
  return extractValue(value, map)
}

// 大额付款状态 1：处理中 2：完成 3：失败 4：退款成功
export function LargePaymentStatusMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.po_trans_status_2'),
      type: 'warning'
    }, {
      value: 2,
      label: i18n.t('map.po_trans_status_3'),
      type: 'success'
    },
    {
      value: 3,
      label: i18n.t('map.po_trans_status_4'),
      type: 'danger'
    }
    // {
    //   value: 4,
    //   label: i18n.t('map.po_trans_status_99'),
    //   type: 'primary'
    // }
  ]
  return extractValue(value, map)
}
export function refundTypeMap(value) {
  const map = [
    {
      value: '0',
      label: i18n.t('map.refunding_status_0'),
      type: 'info'
    },
    {
      value: '1',
      label: i18n.t('map.refunding_status_1'),
      type: 'info'
    },
    {
      value: '2',
      label: i18n.t('map.refunding_status_2'),
      type: 'success'
    },
    {
      value: '3',
      label: i18n.t('map.refunding_status_3'),
      type: 'danger'
    }
    // {
    //   value: '4',
    //   label: i18n.t('map.refunding_status_4'),
    //   type: 'success'
    // },
    // {
    //   value: '5',
    //   label: i18n.t('map.refunding_status_5'),
    //   type: 'warning'
    // }
  ]
  return extractValue(value, map)
}

export function refundStatusMap(value) {
  const map = [
    {
      value: '2',
      label: i18n.t('customerService.full_refund')
    },
    {
      value: '1',
      label: i18n.t('customerService.partial_refund')
    }
  ]
  return extractValue(value, map)
}
export function refundDetailTypeMap(value) {
  const map = [
    {
      value: '0',
      label: i18n.t('map.refunding_status_0'),
      type: 'info'
    },
    {
      value: '1',
      label: i18n.t('map.refunding_status_1'),
      type: 'info'
    },
    {
      value: '2',
      label: i18n.t('map.refunding_status_2'),
      type: 'success'
    },
    {
      value: '3',
      label: i18n.t('map.refunding_status_3'),
      type: 'danger'
    },
    {
      value: '4',
      label: i18n.t('map.refunding_status_6'),
      type: 'warning'
    }
    // {
    //   value: '5',
    //   label: i18n.t('map.refunding_status_5'),
    //   type: 'warning'
    // }
  ]
  return extractValue(value, map)
}

export function refundAgentTypeMap(value) {
  const map = [
    {
      value: '2',
      label: i18n.t('map.refunding_status_2'),
      type: 'success'
    }
  ]
  return extractValue(value, map)
}

// 充值类型 1:线上网银充值 2:线下充值（支票） 3:线下充值（现金）4:Thai QR 支付
export function rechargeTypeMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('data.online_banking'),
      type: 'info'
    }, {
      value: 2,
      label: i18n.t('data.offline_check'),
      type: 'default'
    }, {
      value: 3,
      label: i18n.t('data.offline_cash'),
      type: 'success'
    }, {
      value: 4,
      label: i18n.t('data.thai_qr_payment'),
      type: 'success'
    }, {
      value: 5,
      label: i18n.t('map.balance_type_28'),
      type: 'success'
    }
  ]
  return extractValue(value, map)
}

// 交易类型
export function transactionTypeMap(value) {
  const map = [{
    value: 1,
    label: i18n.t('map.merchant_product_1'),
    type: 'info'
  }, {
    value: 2,
    label: i18n.t('map.merchant_product_2'),
    type: 'info'
  }]
  return extractValue(value, map)
}

// FX交易状态
export function fxTransactionStatusMap(value) {
  const map = [{
    value: 1,
    label: i18n.t('map.common_status_1'),
    type: 'warning'
  },
  {
    value: 2,
    label: i18n.t('map.common_status_2'),
    type: 'success'
  },
  {
    value: 3,
    label: i18n.t('map.common_status_3'),
    type: 'danger'
  }]
  return extractValue(value, map)
}

// 换汇交易类型
export function fxTransactionTypeMap(value) {
  const map = [
    {
      label: i18n.t('map.fx_transaction_type_1'),
      type: 'default'
    },
    {
      label: i18n.t('map.fx_transaction_type_2'),
      type: 'default'
    }
  ]
  return extractValue(value, map)
}
export function repaymentStatusMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.repayment_status_1'),
      type: 'info'
    }, {
      value: 2,
      label: i18n.t('map.repayment_status_2'),
      type: 'default'
    }, {
      value: 3,
      label: i18n.t('map.repayment_status_3'),
      type: 'success'
    }, {
      value: 4,
      label: i18n.t('map.repayment_status_4'),
      type: 'success'
    }
  ]
  return extractValue(value, map)
}

// 充值类型 1:线上网银充值 2:线下充值（支票） 3:线下充值（现金）4:Thai QR 支付
export function repayMethodMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.repay_method_1'),
      type: 'info'
    }, {
      value: 2,
      label: i18n.t('map.repay_method_2'),
      type: 'default'
    }, {
      value: 3,
      label: i18n.t('map.repay_method_3'),
      type: 'success'
    }
  ]
  return extractValue(value, map)
}

export function beneficiaryAccountType(value) {
  const map = [
    {
      value: 'BANK',
      label: i18n.t('map.beneficiary_account_type_0')
    },
    {
      value: 'PROMPTPAY',
      label: i18n.t('map.beneficiary_account_type_1')
    },
    {
      value: 'EWALLET',
      label: i18n.t('map.beneficiary_account_type_2')
    },
    {
      value: 'SBP',
      label: i18n.t('map.beneficiary_account_type_3')
    }
  ]
  return extractValue(value, map)
}

export function beneficiaryType(value) {
  const map = [
    {
      value: 'NATIONAL_ID',
      label: i18n.t('map.beneficiary_type_0')
    },
    {
      value: 'MOBILE_NUMBER',
      label: i18n.t('map.beneficiary_type_1')
    },
    {
      value: 'BANK_ACCOUNT',
      label: i18n.t('map.beneficiary_type_2')
    },
    {
      value: 'CARD_NUMBER',
      label: i18n.t('map.beneficiary_type_3')
    }
  ]
  return extractValue(value, map)
}

export function creditDebitType(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.credit_debit_1')
    },
    {
      value: 2,
      label: i18n.t('map.credit_debit_2')
    }
  ]
  return extractValue(value, map)
}

// 商户类型 1：个人，2：企业
export function billingTypeMap(value) {
  const map = [{
    value: 1,
    label: i18n.t('merchantAccount.per_transaction'),
    type: 'info'
  }, {
    value: 2,
    label: i18n.t('merchantAccount.per_day'),
    type: 'info'
  }]
  return extractValue(value, map)
}

export function transactionFeeChargeMode(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('customerService.charge_to_merchants'),
      type: 'success'
    }, {
      value: 2,
      label: i18n.t('customerService.charge_to_customer'),
      type: 'success'
    }]
  return extractValue(value, map)
}

export function productCategoryMap(value) {
  const map = [
    {
      value: 1,
      label: 'Web Payment'
    },
    {
      value: 2,
      label: 'VA'
    },
    {
      value: 3,
      label: 'Bill VA'
    },
    {
      value: 4,
      label: 'Qrcode(MPM)'
    },
    {
      value: 5,
      label: 'CPM'
    },
    {
      value: 6,
      label: 'Direct Debit'
    },
    {
      value: 7,
      label: 'Paylater'
    },
    {
      value: 8,
      label: 'EDC'
    },
    {
      value: 9,
      label: 'CARD'
    },
    {
      value: 10,
      label: 'Authorization Hold'
    }
  ]
  return extractValue(value, map)
}

export function receiverRelationMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.receiver_relation_map_1')
    },
    {
      value: 2,
      label: i18n.t('map.receiver_relation_map_2')
    },
    {
      value: 3,
      label: i18n.t('map.receiver_relation_map_3')
    },
    {
      value: 4,
      label: i18n.t('map.receiver_relation_map_4')
    },
    {
      value: 5,
      label: i18n.t('map.receiver_relation_map_5')
    },
    {
      value: 6,
      label: i18n.t('map.receiver_relation_map_6')
    },
    {
      value: 7,
      label: i18n.t('map.receiver_relation_map_7')
    },
    {
      value: 8,
      label: i18n.t('map.receiver_relation_map_8')
    },
    {
      value: 9,
      label: i18n.t('map.receiver_relation_map_9')
    },
    {
      value: 10,
      label: i18n.t('map.receiver_relation_map_10')
    },
    {
      value: 11,
      label: i18n.t('map.receiver_relation_map_11')
    }
  ]
  return extractValue(value, map)
}

export function receiverTypeMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.receiver_type_map_1')
    },
    {
      value: 2,
      label: i18n.t('map.receiver_type_map_2')
    },
    {
      value: 3,
      label: i18n.t('map.receiver_type_map_3')
    }
  ]
  return extractValue(value, map)
}

export function splitStatusMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.split_status_map_1'),
      type: 'info'
    },
    {
      value: 2,
      label: i18n.t('map.split_status_map_2'),
      type: 'success'
    },
    {
      value: 3,
      label: i18n.t('map.split_status_map_3'),
      type: 'danger'
    }
  ]
  return extractValue(value, map)
}

// 收款人账户类型 1:手机号 2:个人 3:组织 4:银行账户 5:卡号
export function beneficiaryTypeMap(value) {
  const map = [
    {
      value: 1,
      label: 'MOBILE_NUMBER',
      type: 'success'
    },
    {
      value: 2,
      label: 'INDIVIDUAL',
      type: 'success'
    },
    {
      value: 3,
      label: 'ORGANIZATION',
      type: 'success'
    },
    {
      value: 4,
      label: 'BANK_ACCOUNT',
      type: 'success'
    },
    {
      value: 5,
      label: 'CARD_NUMBER',
      type: 'success'
    }
  ]
  return extractValue(value, map)
}

export function transactionStatusMap(value) {
  const map = [{
    value: 1,
    label: i18n.t('map.transaction_status_1')
  },
  {
    value: 2,
    label: i18n.t('map.transaction_status_2')
  },
  {
    value: 3,
    label: i18n.t('map.transaction_status_3')
  }
  ]
  return extractValue(value, map)
}

export function cardValidationStatusMap(value) {
  const map = [{
    value: 1,
    label: i18n.t('data.card_verifying'),
    type: 'warning'
  },
  {
    value: 2,
    label: i18n.t('data.card_verification_success'),
    type: 'success'
  },
  {
    value: 3,
    label: i18n.t('data.card_verification_failed'),
    type: 'danger'
  }
  ]
  return extractValue(value, map)
}

// 账户姓名匹配结果 1: MATCH, 2: NOT_MATCH, 3: UNKNOWN
export function accountNameMatchResultMap(value) {
  const map = [
    { value: 1, label: i18n.t('data.account_name_match'), type: 'success' },
    { value: 2, label: i18n.t('data.account_name_not_match'), type: 'danger' },
    { value: 3, label: i18n.t('data.account_name_unknown'), type: 'info' }
  ]
  return extractValue(value, map)
}

// 卡号状态结果 1: VALID, 2: INVALID, 3: UNKNOWN
export function accountValidateResultMap(value) {
  const map = [
    { value: 1, label: i18n.t('data.account_validate_valid'), type: 'success' },
    { value: 2, label: i18n.t('data.account_validate_invalid'), type: 'danger' },
    { value: 3, label: i18n.t('data.account_validate_unknown'), type: 'info' }
  ]
  return extractValue(value, map)
}

// 账户类型
export function accountTypeMap(value) {
  const map = [
    { value: 1, label: i18n.t('data.account_type_bank') },
    { value: 2, label: i18n.t('data.account_type_ewallet') },
    { value: 3, label: i18n.t('data.account_type_va') },
    { value: 4, label: i18n.t('data.account_type_unknown') }
  ]
  return extractValue(value, map)
}

// 账号真实KYC状态 1: KYC, 2: NON-KYC, 3: UNKNOWN
export function accountKycResultMap(value) {
  const map = [
    { value: 1, label: 'KYC' },
    { value: 2, label: 'NON-KYC' },
    { value: 3, label: 'UNKNOWN' }
  ]
  return extractValue(value, map)
}

export function activeStatusMap(value) {
  const map = [{
    value: 1,
    label: i18n.t('payment_links.active'),
    type: 'success'
  },
  {
    value: 2,
    label: i18n.t('payment_links.inactive'),
    type: 'info'
  }
  ]

  return extractValue(value, map)
}

export function linkModeMap(value) {
  const map = [{
    value: 1,
    label: i18n.t('payment_links.fixed_amount')
  },
  {
    value: 2,
    label: i18n.t('payment_links.based_on_product')
  },
  {
    value: 3,
    label: i18n.t('payment_links.customer_to_enter')
  }
  ]
  return extractValue(value, map)
}

export function collectModeMap(value) {
  const map = [{
    value: 1,
    label: i18n.t('components.yes')
  },
  {
    value: 2,
    label: i18n.t('components.no')
  }
  ]
  return extractValue(value, map)
}

export function addCustomerFieldModeMap(value) {
  const map = [{
    value: 1,
    label: i18n.t('components.yes')
  },
  {
    value: 2,
    label: i18n.t('components.no')
  }
  ]
  return extractValue(value, map)
}

export function customerTypeMap(value) {
  const map = [{
    value: 1,
    label: i18n.t('payment_links.text')
  },
  {
    value: 2,
    label: i18n.t('payment_links.number_only')
  }
  ]
  return extractValue(value, map)
}

export function linkTypeMap(value) {
  const map = [{
    value: 1,
    label: i18n.t('payment_links.one_time')
  },
  {
    value: 2,
    label: i18n.t('payment_links.reusable')
  }
  ]
  return extractValue(value, map)
}

export function statusMap(value) {
  const map = [{
    value: 1,
    label: i18n.t('components.on')
  },
  {
    value: 2,
    label: i18n.t('components.off')
  }
  ]
  return extractValue(value, map)
}

export function checkoutOrderStatusMap(value) {
  const map = [{
    value: 1,
    label: i18n.t('map.checkout_order_status_1'),
    type: 'info'
  },
  {
    value: 2,
    label: i18n.t('map.checkout_order_status_2'),
    type: 'success'
  },
  {
    value: 3,
    label: i18n.t('map.checkout_order_status_3'),
    type: 'danger'
  }
  ]
  return extractValue(value, map)
}

export function paymentMethodMap(value) {
  const map = [
    {
      value: 1,
      label: 'Web Payment'
    }, {
      value: 2,
      label: 'VA'
    }, {
      value: 3,
      label: ''
    }, {
      value: 4,
      label: 'QR(MPM) '
    }, {
      value: 5,
      label: 'CPM'
    }]
  return extractValue(value, map)
}

// 越南(VN)收款人账户类型可选项
export function beneficiaryTypeOptionsForVN() {
  return [
    {
      value: 4,
      label: 'BANK_ACCOUNT'
    },
    {
      value: 5,
      label: 'CARD_NUMBER'
    }
  ]
}
